import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const WorkingCapitalChart = () => {
  const dates = [
    "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20",
    "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21",
    "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22",
    "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23",
    "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
  ];

  const workingCapital = [
    21507.80, 10148.86, 17759.36, 85593.77, 84361.53, 66219.23, 106532.08, 141703.36, 147487.81, 252123.76, 291043.88, 305384.52,
    352541.09, 382666.82, 354236.90, 332389.80, 251433.83, 223553.01, 142430.33, 221350.23, 241803.05, 259442.70, 291013.79, 258373.81,
    312340.92, 314231.56, 302228.62, 386048.11, 313700.29, 322012.67, 345012.98, 354506.57, 437374.31, 398107.54, 473985.35, 561311.18,
    528601.67, 555981.37, 542122.26, 555955.43, 664175.53, 539277.31, 540472.48, 357325.12, 368717.55, 323746.97, 402786.85, 487629.89,
    647064.54, 655747.03, 657394.43, 670864.45, 712475.68, 875759.39, 836863.70, 798959.89, 895617.28, 1040823.11, 1108362.68, 1121420.92
  ];

  // Calculate the trend line for Working Capital
  const trendLine = getLinearTrend(workingCapital);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Working Capital", "Trend Line"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value} $",
      },
    },
    series: [
      {
        name: "Working Capital",
        type: "line",
        data: workingCapital,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Trend Line",
        type: "line",
        data: trendLine,
        smooth: true,
        lineStyle: { type: "dashed", color: "red" },
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default WorkingCapitalChart;
